import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ClaimsService } from 'src/app/core/services/claims.service';
import { TempService } from 'src/app/core/services/temp.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-mail-box',
  templateUrl: './mail-box.component.html',
  styleUrls: ['./mail-box.component.scss']
})
export class MailBoxComponent implements OnInit {

  @Output() refreshClaimEvent = new EventEmitter<string>();
  @Output() closeMailEvent = new EventEmitter<any>();
  @Input() claimDetails: any;

  ngOnChanges(changes: SimpleChanges) {
    this.setClaimDetails(changes.claimDetails.currentValue);
  }

  claimDetailsSend: any;

  constructor(
    private tempservice : TempService,public claimsService:ClaimsService,private router: Router
  ) { }

  view: any;

  mailDetails: any;

  ngOnInit(): void {
    this.view = 'list';
    this.getNotificationsDetail();
  }

  setClaimDetails(details: any) {
    this.claimDetailsSend = details;
  }

  refreshClaimDetails(value: any) {
    this.refreshClaimEvent.emit(value);
  }

  closeMail(value: any) {
    
    this.closeMailEvent.emit(value);   
    localStorage.setItem('sidenav', 'false');

  }

  switchView(view: any) {
    if (view === 'details') {
      this.view = 'details';
    } else {
      this.view = 'list';
    }
  }

  fetchMailDetails(data: any) {
    this.mailDetails = data;
  }

  refresh(newItem: any) {
    this.refreshClaimDetails(newItem);
  }


  notification:any;
  spinner:boolean= true
  getNotificationsDetail(){
    this.tempservice.getNotificationDetails().subscribe((res:any)=>{
      if(res){
        this.notification = res.body;
        this.spinner = false  
      }
    }
    ,
    (err: any) => {
      Swal.fire('', err ? err : err, 'error');
      this.spinner = false
    })
  }

  clearNotification(claimId:any){
    console.log(claimId);
    this.tempservice.clearNotifications(claimId).subscribe((res:any)=>{
      if(res){
        console.log(res);
        this.getNotificationsDetail();
      }
    },(err: any) => {
      Swal.fire('', err ? err : err, 'error');
    })
  }


  


  openClaimDetails(claimId: any, state: any) {
    Swal.showLoading();
    const tempClaimId = claimId.split('/').join('_');
    if (state === 'assign') {
      this.claimsService.isClaimAssign(claimId).subscribe(
        (data: any) => {
          if (data.body && data.message != 'Claim assigned to the requesting user.') {
            Swal.fire(data.message, '', 'info')
          } else {
            this.claimsService.assignClaim(claimId).subscribe(
              (assignClaim: any) => {
                Swal.close();
                Swal.fire(assignClaim.message, '', 'info')
                this.router.navigate(['/claims/claimDetails/' + tempClaimId + '/' + state], { queryParams: { claimData: JSON.stringify(assignClaim.body) }, skipLocationChange: true });
              }, error => {
                Swal.close();
                Swal.fire(error, '', 'error')
              }
            )
          }
        }, error => {
          Swal.close();
          Swal.fire(error, '', 'error')
        }
      )
    } else {
      this.router.navigate(['/claims/claimDetails/' + tempClaimId + '/' + state], {skipLocationChange: true});
    }
  }

  
}
